// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text[data-v-1bea0136]{--tw-text-opacity:1;color:#f1832f;color:rgb(241 131 47/var(--tw-text-opacity));cursor:pointer;font-size:.875rem;transition-duration:.15s;-webkit-user-select:none;-moz-user-select:none;user-select:none}.text[data-v-1bea0136]:hover{opacity:.5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
